// @flow
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import isServer from 'utils/isServer';
import { Grid, Row, Col } from 'Common/Grid';
import Image from 'Common/Image';
import Icon from 'Common/Icon';
import Button from 'Common/Button';
import isWorkingHours from 'utils/isWorkingHours';
import classNames from 'classnames';

import styles from './NavBar.scss';

const ctaClick = (label, pushGtmCTA, buttonOnClick) => event => {
  event && event.stopPropagation();
  pushGtmCTA && pushGtmCTA(`${label} dealer`);
  buttonOnClick && buttonOnClick(label);
};

const NavBar = props => {
  const { title, image, price, phoneNumber, pushGtmCTA, buttonOnClick } = props;
  const decodedNumber =
    !isServer() && phoneNumber ? window.atob(phoneNumber) : '';
  const img = image && image['image'] && image['image']['sm'];
  return (
    <Grid>
      <Row>
        <Col colXs={12}>
          <div className={styles.container}>
            <div className={styles.innerContainer}>
              {img && (
                <Image src={img} alt={image['alt']} title={image['title']} />
              )}
              <div>{title}</div>
              <div className={styles.price}>{price}</div>
            </div>
            <div
              className={classNames(
                styles.innerContainer,
                styles.phoneContainer
              )}
            >
              {decodedNumber && isWorkingHours() && (
                <Fragment>
                  <Icon
                    iconName={'phone2'}
                    size={'large'}
                    className={styles.icon}
                  />
                  <a
                    href={`tel:${decodedNumber}`}
                    title={'Dealer Phone Number'}
                    onClick={ctaClick('phone', pushGtmCTA)}
                  >
                    Call
                  </a>
                </Fragment>
              )}
              <Button
                buttonText={'Message dealer'}
                gaLabel="heycar-message-dealer-button"
                onClick={ctaClick('message', pushGtmCTA, buttonOnClick)}
              />
              {!isWorkingHours() && (
                <Button
                  buttonText={'Request callback'}
                  gaLabel="heycar-callback-dealer-button"
                  onClick={ctaClick('callback', pushGtmCTA, buttonOnClick)}
                  type={'transparent'}
                  extendStyle={styles.callback}
                />
              )}
            </div>
          </div>
        </Col>
      </Row>
    </Grid>
  );
};

NavBar.propTypes = {
  title: PropTypes.string.isRequired,
  image: PropTypes.object,
  price: PropTypes.string,
  phoneNumber: PropTypes.string,
  pushGtmCTA: PropTypes.func,
  buttonOnClick: PropTypes.func
};

export default NavBar;



// WEBPACK FOOTER //
// ./src/Detail/NavBar/index.js